export default __webpack_public_path__ + "static/media/homeloan.b84e107e.jpg";